var alignment_rtlignore_default = {
  "alignLeft": "srpF3",
  "textWrapNowrap": "VLOil",
  "alignRight": "t9Jqi",
  "alignCenter": "_83OZq",
  "sizeFullWidth": "TGAhJ",
  "renderedInTable": "tqLxD",
  "sizeOriginal": "qvhkY",
  "sizeContent": "_5RPM7",
  "sizeSmall": "iu6Lj",
  "sizeSmallCenter": "QoUPd",
  "flex": "NVMVh",
  "LEFT": "Ap-UL",
  "CENTER": "q0OVS",
  "RIGHT": "yoyXQ",
  "AUTO": "_3vg-l",
  "JUSTIFY": "lFRiw"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
